export default {
  pendingLabel: 'Pending',
  openedLabel: 'Open',
  holdingLabel: 'On Hold',
  repliedLabel: 'Replied',
  closedLabel: 'Closed',
  ignoredLabel: 'Ignored',
};
